import React from 'react';
import clsx from 'clsx';
import { formatNumber, getCurrencySymbol } from 'utils/currency.helpers';

import { Box, Divider, Typography } from '@alpha/ui-lib/ui/external';
import { Flag } from '@alpha/ui-lib/ui/Flag';
import { Status } from '@alpha/ui-lib/ui/Status';
import { APTooltip } from '@alpha/ui-lib/ui/Tooltip/APTooltip';

import { TData } from '../Dropdown';

import { useStyles } from './Item.styles';

interface IProps {
  item: TData;
  hideBalance?: boolean;
}
const Data: React.FC<IProps> = (props: IProps) => {
  const { item, hideBalance } = props;
  const styles = useStyles();
  const bankInfo = item.iban
    || item.swift
    || item.accountNumber
    || item.sortCode
    || item.reference
    || '-';
  const currencySymbol = getCurrencySymbol(item.currencyCode!);
  const formattedBalance = formatNumber(+item.balance, 2);
  const currencySymbolAndFormattedBalance = `${currencySymbol}${formattedBalance}`;

  return (
    <Box className={clsx(styles.root, styles.item, item.externalAccount && styles.isExternal)}>
      <APTooltip
        title={`${item.friendlyName || '-'}       ${!hideBalance ? currencySymbolAndFormattedBalance : '...'}       ${bankInfo}`}
        data-dd-privacy="mask"
      >
        <Box className={styles.root}>
          <Typography variant="subtitle1" className={styles.friendlyName}>
            {item.friendlyName || '-'}
          </Typography>
          <Divider orientation="vertical" variant="middle" light style={{ height: '24px' }} />
          <Typography variant="subtitle1" className={styles.friendlyName} data-dd-privacy="mask">
            {currencySymbolAndFormattedBalance || '-'}
          </Typography>
          <Divider orientation="vertical" variant="middle" light style={{ height: '24px' }} />
          <Typography variant="subtitle1" className={styles.bankInfo} data-dd-privacy="mask">
            {bankInfo || '-'}
          </Typography>
        </Box>
      </APTooltip>
      {
        item.externalAccount ? (
          <APTooltip title={`${item.clientAccountName || '-'}`}>
            <div className={styles.externalBadge}>
              <Status variant="info">External</Status>
            </div>
          </APTooltip>
        ) : null
      }
    </Box>
  );
};

interface IStickyProps {
  currencyCode: string;
}
const Sticky: React.FC<IStickyProps> = (props: IStickyProps) => {
  const { currencyCode } = props;
  const styles = useStyles();

  return (
    <Box className={clsx(styles.root, styles.sticky)}>
      <Box className={styles.imageHolder}>
        <Flag code={currencyCode} size="md" />
      </Box>
      <Typography variant="subtitle1">{currencyCode}</Typography>
    </Box>
  );
};

export const Item = {
  Data,
  Sticky,
};

export default Data;
